export default __webpack_public_path__ + "static/media/4.54343a38.webp";